/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as BicepsDemoRouteImport } from './routes/biceps-demo'
import { Route as IndexRouteImport } from './routes/index'

const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const BicepsDemoRoute = BicepsDemoRouteImport.update({
  id: '/biceps-demo',
  path: '/biceps-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/biceps-demo': typeof BicepsDemoRoute
  '/history': typeof HistoryRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/biceps-demo': typeof BicepsDemoRoute
  '/history': typeof HistoryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/biceps-demo': typeof BicepsDemoRoute
  '/history': typeof HistoryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/biceps-demo' | '/history'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/biceps-demo' | '/history'
  id: '__root__' | '/' | '/biceps-demo' | '/history'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BicepsDemoRoute: typeof BicepsDemoRoute
  HistoryRoute: typeof HistoryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/biceps-demo': {
      id: '/biceps-demo'
      path: '/biceps-demo'
      fullPath: '/biceps-demo'
      preLoaderRoute: typeof BicepsDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BicepsDemoRoute: BicepsDemoRoute,
  HistoryRoute: HistoryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
